/**
 * 
 */
class BaseComponent {
  constructor({store}) {
    if (store) {
      this.store = store;
    }
  }
}
BaseComponent.Use = function({store}) {
  BaseComponent.prototype.$store = store;
}

export default BaseComponent;